import { ParseQuery } from './parse-query'

import { ProductInput } from '@shared/data'

export class ProductInputQuery extends ParseQuery<ProductInput> {
  constructor() {
    super(ProductInput.CLASS_NAME)
  }
}